














































































































































import { Component, Vue } from 'vue-property-decorator'

@Component

export default class ComponentModalSolicitacaoCirurgiaMedicoOpcoes extends Vue {
  messages: any[] = [{ descricao: 'fornecer OPME da solicitação' }, { descricao: 'fornecer nome completo' }]
  dates: any[] = [{ day: '10/10/20', hour: '10:10' }, { day: '10/10/20', hour: '11:10' }, { day: '10/10/20', hour: '12:10' }]
}

